import styles from './styles/stationList.module.scss';

const StationGmRadiusListElement = ({onClick, description}) => (
  <li className={styles.element} onClick={onClick}>
    {description}
  </li>
);

export default StationGmRadiusListElement;
